export default {
    'required': 'Campo obrigatório',
    'diff_date_in_month': 'As datas devem ter uma diferença de no máximo 12 meses',
    'diff_date_in_three_month': 'As datas devem ter uma diferença de no máximo 3 meses',
}
